import React, { useCallback, useContext, useState } from 'react'

import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'

import { GlobalContext } from '../../Providers/GlobalProvider'
import { getUser } from '../../reducers/UserReducer'
import HolidayPeriodsTable from './HolidayPeriodsTable'
import useQuery from '../../hooks/useQuery'
import { TableParameters } from '../../utils/entities/tableParameters'
import { getSchoolPeriods } from '../../utils/api/schoolPeriods'
import useSchoolPeriod from '../../utils/api/hooks/useSchoolPeriod'
import SchoolPeriodFormModalProvider from '../../Providers/Forms/SchoolPeriodForm/SchoolPeriodModalProvider'
import { resolvePromises } from '../../utils/apiHelper'
import { UpdateModes } from '../../utils/enums/enums'
import { OrderBy } from '../../utils/constants'
import { getIdOrNull } from '../../utils'
import { SchoolPeriod } from '../../utils/entities/schoolPeriod'

const mapStateToProps = state => ({ user: getUser(state.getUser), t: getTranslate(state.locale) })

export const HolidayActions = Object.freeze({
  DELETE: 'HOLIDAY_DELETE',
  DUPLICATE: 'HOLIDAY_DUPLICATE'
})

const HOOK_MODE = UpdateModes.SYNCHRONOUS

const DEFAULT_TABLE_PARAMS = {
  order: { by: OrderBy.START_DATE },
  pageSize: 20
}

const HolidayPeriodsManagement = ({ user, t }) => {
  const { isReadOnly } = useContext(GlobalContext)
  const [tableParameters, setTableParameters] = useState(new TableParameters({ ...DEFAULT_TABLE_PARAMS }))

  const periodsGetter = useQuery({
    request: getSchoolPeriods,
    defaultParameters: new TableParameters(tableParameters).clone({ filters: { school: getIdOrNull(user.school) } }).toQueryParameters(),
    select: periods => periods.map(p => new SchoolPeriod(p))
  })

  const periodsHandler = useSchoolPeriod({ user, t, mode: HOOK_MODE, callback: periodsGetter.refetch })

  const handleTableParametersChange = useCallback(tableParameters => {
    const queryParameters = new TableParameters({
      ...periodsGetter.parameters,
      ...tableParameters
    }).toQueryParameters()

    periodsGetter.setParameters(queryParameters)
    setTableParameters(queryParameters)
  }, [periodsGetter.parameters])

  const handleAction = useCallback((...itemActionPairs) => {
    const promises = []

    for (let iPair = 0; iPair < itemActionPairs.length; iPair += 2) {
      const item = itemActionPairs[iPair]
      const action = itemActionPairs[iPair + 1]

      if (action === HolidayActions.DELETE) {
        promises.push(periodsHandler.delete(item))
      } else if (action === HolidayActions.DUPLICATE) {
        promises.push(periodsHandler.duplicate(item))
      }
    }

    resolvePromises(promises).then(periodsGetter.refetch)
  }, [periodsHandler.delete, periodsHandler.duplicate, periodsGetter.refetch])

  return (
    <>
      <SchoolPeriodFormModalProvider mode={HOOK_MODE}>
        <HolidayPeriodsTable
          data={periodsGetter.data}
          metadata={periodsGetter.metadata}
          loading={periodsGetter.loading}
          tableParameters={tableParameters}
          isReadOnly={isReadOnly}
          onAction={handleAction}
          onTableParametersChange={handleTableParametersChange}
        />
      </SchoolPeriodFormModalProvider>
    </>
  )
}

export default connect(mapStateToProps)(HolidayPeriodsManagement)
